"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hoursOfOperationSchema = void 0;
const joi_1 = __importDefault(require("joi"));
const GenericValidator_1 = __importDefault(require("../../shared/validators/GenericValidator"));
exports.hoursOfOperationSchema = joi_1.default.object().pattern(/[1-7]/, joi_1.default.object({
    isOpen: joi_1.default.boolean().required(),
    open: joi_1.default.string().when('isOpen', {
        is: true,
        then: joi_1.default.string().required(),
        otherwise: joi_1.default.string(),
    }),
    close: joi_1.default.string().when('isOpen', {
        is: true,
        then: joi_1.default.string().required(),
        otherwise: joi_1.default.string(),
    }),
}));
class HoursOfOperationValidator extends GenericValidator_1.default {
    validate(input) {
        super.validate(input, 'IHoursOfOperation', exports.hoursOfOperationSchema);
    }
}
exports.default = HoursOfOperationValidator;
